
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetotrimkedhwarcrystacab() {



    const cardData =
    {
        keyword: 'Pune to Trimbakeshwar Innova Crysta Cab',
        heading: 'Meghana Cab : Pune to Trimbakeshwar Innova Crysta Cab',
        headingDescription: 'Meghana Cab offers Pune to Trimbakeshwar Innova Crysta Cab Service, providing a serene, comfortable, and spiritual journey to the sacred Jyotirlinga temple town nestled in the Western Ghats. Covering approximately 240–243 km via NH‑60/NH‑848 over 5 to 6 hours, our Innova Crysta vehicles feature plush leather interiors, ample legroom, generous luggage space, and full air-conditioning . Ideal for devotees, family outings, or weekend getaways, you’ll enjoy door-to-door pickups from anywhere in Pune, experienced chauffeurs familiar with ghat roads and scenic stops, and GPS-enabled vehicles. With flexible booking options (one-way, round-trip, or hourly), transparent service, and 24/7 customer support, Meghana Cab ensures your Pune to Trimbakeshwar Innova Crysta journey is a stress-free, luxurious, and uplifting experience from start to finish.',


        top: ' Top Places to Visit in Trimbakeshwar with Meghana Cab',

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga Temple",
    "description": "One of the 12 Jyotirlingas of Lord Shiva, Trimbakeshwar is uniquely sacred for its three-faced lingam symbolizing Brahma, Vishnu, and Shiva. Located at the source of the Godavari River in the Brahmagiri Hills, this 18th-century temple—built by Peshwa Nana Saheb—is constructed with black stone and crowned by an ornate shikhara. It’s a spiritual hub for pilgrims performing Narayan Nagbali, Kalsarpa Shanti, and Pitru Dosh rituals. The temple exudes divinity, especially during festivals like Mahashivratri and Shravan Maas."
  },
  {
    "title": "Brahmagiri Hill",
    "description": "Rising behind the Trimbakeshwar temple, Brahmagiri Hill is considered the origin of the Godavari River. A climb of nearly 750 stone steps takes you to scenic viewpoints, ancient caves, and sacred tanks like Gangadwar and Ramkund. The area is surrounded by lush forest and spiritual calm, making it ideal for both pilgrimage and nature trekking."
  },
  {
    "title": "Kushavarta Kund",
    "description": "This sacred tank, believed to be the symbolic starting point of the Godavari River, is located right in the temple town. Devotees perform holy dips and ancestral rituals here to seek spiritual cleansing. The kund is surrounded by shrines and has beautifully sculpted stone steps with water flowing year-round."
  },
  {
    "title": "Gautami Ganga Dam",
    "description": "Located a short distance from Trimbakeshwar, this picturesque dam on the Gautami branch of the Godavari River is surrounded by greenery and hills. It’s a peaceful spot for picnics, local photography, and quiet reflection near nature, away from the temple bustle."
  },
  {
    "title": "Anjaneri Fort",
    "description": "Situated between Nashik and Trimbakeshwar, Anjaneri is believed to be the birthplace of Lord Hanuman. The trek to the fort offers breathtaking views, lush landscapes, and small temples dedicated to Anjani Mata and Hanuman. Caves and rock-cut trails add historical intrigue to this spiritually charged location."
  },
  {
    "title": "Nilparvat Hill",
    "description": "Adjacent to Brahmagiri, Nilparvat Hill houses several smaller temples such as Bilva Tirtha and Swami Samarth Temple. Offering panoramic views of the Trimbak region, it’s a favored spot for sunset watchers and peaceful walks. The serenity of the hill draws both nature lovers and pilgrims."
  },
  {
    "title": "Nivruttinath Samadhi Mandir",
    "description": "This sacred shrine is dedicated to Nivruttinath, the elder brother of Sant Dnyaneshwar and a key figure in the Nath tradition. Located near Trimbakeshwar, the temple attracts devotees of the Bhakti movement and spiritual seekers interested in Maharashtra’s saint lineage."
  },
  {
    "title": "Harihar Fort",
    "description": "Located near Trimbak, Harihar Fort is known for its thrilling vertical staircase carved into rock. Also called Harshgad, the fort offers panoramic views of the Sahyadri ranges and is popular among adventure seekers and trekkers who want a mix of history, nature, and challenge."
  }
],

      "services": [
    {
      "name": "Pune to Trimbakeshwar Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Trimbakeshwar for a serene and spiritual journey. Enjoy a comfortable ride through scenic routes with our chauffeur-driven service ideal for pilgrims and families visiting the revered Trimbakeshwar Jyotirlinga temple."
    },
    {
      "name": "One Way Innova Crysta Pune Trimbakeshwar",
      "description": "Choose our affordable one-way Innova Crysta cab service from Pune to Trimbakeshwar. Ideal for pilgrims and travelers planning a single-leg journey without the need for a return trip."
    },
    {
      "name": "Round Trip Innova Crysta Pune Trimbakeshwar",
      "description": "Opt for a round-trip Innova Crysta cab service to and from Trimbakeshwar. Get the convenience of the same vehicle, flexible return timings, and a hassle-free pilgrimage experience."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Trimbakeshwar",
      "description": "Travel in total comfort with our air-conditioned Innova Crysta cabs. Designed to handle long-distance drives like Pune to Trimbakeshwar while keeping the cabin cool and relaxing."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Trimbakeshwar",
      "description": "Our experienced chauffeurs ensure safe and respectful service for your spiritual journey. They are familiar with temple timings and best routes, adding peace of mind to your trip."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Trimbakeshwar",
      "description": "Enjoy a fully private Innova Crysta ride for your family or group. No shared rides—just comfort, privacy, and control over your schedule while traveling to Trimbakeshwar."
    },
    {
      "name": "Online Booking Innova Crysta Pune Trimbakeshwar",
      "description": "Book your cab online easily and securely. Real-time vehicle availability, transparent fares, and instant booking confirmation for your Pune to Trimbakeshwar journey."
    },
    {
      "name": "Trimbakeshwar Pilgrimage Innova Crysta",
      "description": "Our Trimbakeshwar pilgrimage cab service is ideal for spiritual seekers and devotees. Visit the sacred Jyotirlinga in total comfort with flexible halts and a knowledgeable chauffeur."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Trimbakeshwar",
      "description": "Recline and relax in plush seating, clean interiors, and smooth suspension—making your long-distance religious journey both peaceful and comfortable."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Trimbakeshwar",
      "description": "Affordable rates for a premium ride. Get luxury-level comfort at budget-friendly pricing, with no hidden charges for your Pune to Trimbakeshwar taxi ride."
    },
    {
      "name": "Religious Tour Innova Crysta Pune",
      "description": "We provide curated cab packages for temple tours including Trimbakeshwar, Bhimashankar, and other Jyotirlingas—perfect for group and family spiritual outings."
    },
    {
      "name": "Family Trip Innova Crysta Trimbakeshwar",
      "description": "Our 6–7 seater Innova Crysta is ideal for family travel. With spacious interiors and ample luggage space, your pilgrimage to Trimbakeshwar is sure to be stress-free."
    },
    {
      "name": "Reliable Innova Crysta Taxi Trimbakeshwar",
      "description": "Punctual pickups, professional chauffeurs, and well-maintained vehicles make our Innova Crysta service a trusted choice for your Trimbakeshwar journey."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Innova Crysta is built for long routes. Enjoy excellent road stability, comfort features, and safety on your Pune to Trimbakeshwar round trip or extended religious tour."
    },
    {
      "name": "Weekend Trip Innova Crysta Trimbakeshwar",
      "description": "Plan your weekend spiritual escape from Pune to Trimbakeshwar with our cab service. Flexible pickup times and return options to suit your itinerary."
    }
  ],
  "tableData": [
    ["Pune to Trimbakeshwar Innova Crysta Cab Booking", "One Way Innova Crysta Pune Trimbakeshwar"],
    ["Round Trip Innova Crysta Pune Trimbakeshwar", "AC Innova Crysta Taxi Pune Trimbakeshwar"],
    ["Chauffeur Driven Innova Crysta Pune Trimbakeshwar", "Private Innova Crysta Taxi Pune Trimbakeshwar"],
    ["Online Booking Innova Crysta Pune Trimbakeshwar", "Trimbakeshwar Pilgrimage Innova Crysta"],
    ["Comfortable Innova Crysta Cab Pune Trimbakeshwar", "Budget Innova Crysta Taxi Pune Trimbakeshwar"],
    ["Religious Tour Innova Crysta Pune", "Family Trip Innova Crysta Trimbakeshwar"],
    ["Reliable Innova Crysta Taxi Trimbakeshwar", "Long Distance Innova Crysta Taxi"],
    ["Weekend Trip Innova Crysta Trimbakeshwar", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab for Pune to Trimbakeshwar Travel",
    "WhyChoosedescription": "Book a premium Innova Crysta cab for your pilgrimage from Pune to Trimbakeshwar, one of the most sacred Jyotirlinga temples in India. Enjoy a smooth, spiritual journey with our spacious and comfortable vehicle, ideal for families and groups."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Ride for Long Distance",
    "WhyChoosedescription": "Travel the 230+ km distance from Pune to Trimbakeshwar in an Innova Crysta that offers ample legroom, reclining seats, powerful AC, and generous luggage space—ensuring a relaxed trip for up to 6–7 passengers."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs with Temple Route Knowledge",
    "WhyChoosedescription": "Our drivers are well-acquainted with the Nashik route and Trimbakeshwar temple area. They ensure a safe, timely journey and can guide you on ideal darshan hours, local stopovers, and rest points."
  },
  {
    "WhyChooseheading": "Well-Maintained, Sanitized, and Safe Vehicles",
    "WhyChoosedescription": "Every Innova Crysta is regularly cleaned, sanitized, and maintained for mechanical reliability. We prioritize hygiene and vehicle safety so your spiritual journey remains peaceful and uninterrupted."
  },
  {
    "WhyChooseheading": "Flexible Booking Options – One-Way, Round Trip, or Stay Plan",
    "WhyChoosedescription": "Whether you're planning a same-day return or an overnight stay in Trimbak or Nashik, we offer flexible travel packages with personalized pickup/drop-off points from anywhere in Pune."
  },
  {
    "WhyChooseheading": "All-Inclusive Transparent Pricing",
    "WhyChoosedescription": "Our cab packages include driver allowance, fuel charges, tolls, parking, and taxes. We provide a clear fare structure upfront, so you can enjoy your Yatra without worrying about unexpected costs."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimages, Family Tours, and Senior Citizens",
    "WhyChoosedescription": "Our Innova Crysta is the perfect vehicle for pilgrimage trips, offering both comfort and accessibility for elders and family members. Enjoy a spiritually enriching experience without the fatigue of travel."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Yatra Coordination",
    "WhyChoosedescription": "Our customer service team is available round-the-clock to assist you with bookings, rescheduling, and itinerary planning. We help you organize your Pune to Trimbakeshwar trip with ease and convenience."
  }
]






















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta from Pune to Trimbakeshwar?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or through our official website for instant confirmation."
    },
    {
        question: "What is the distance and travel time from Pune to Trimbakeshwar?",
        answer: "The distance is approximately 240 km, and it takes around 5 to 6 hours to reach Trimbakeshwar from Pune by road."
    },
    {
        question: "Is the Innova Crysta comfortable for long-distance temple trips?",
        answer: "Yes, the Innova Crysta is ideal for long trips with spacious seating, smooth suspension, and ample luggage space."
    },
    {
        question: "Can I book a one-way or round-trip cab to Trimbakeshwar?",
        answer: "Yes, we offer both one-way and round-trip options depending on your travel requirement."
    },
    {
        question: "Are your vehicles sanitized before each trip?",
        answer: "Absolutely, all vehicles are sanitized thoroughly before every trip to ensure hygiene and safety."
    },
    {
        question: "What is included in the fare for the Pune to Trimbakeshwar Innova Crysta cab?",
        answer: "The fare includes fuel, driver allowance, and tolls. Any extra parking or extended stopovers may incur additional charges."
    },
    {
        question: "Can we take stops for meals or rest during the journey?",
        answer: "Yes, you can request stops for meals, refreshments, or breaks at any convenient location during the ride."
    },
    {
        question: "Is the driver familiar with the route to Trimbakeshwar?",
        answer: "Yes, our drivers are experienced and well-versed with the Pune–Nashik–Trimbakeshwar route."
    },
    {
        question: "How many people can comfortably travel in the Innova Crysta?",
        answer: "The vehicle accommodates 6 to 7 passengers comfortably, along with luggage."
    },
    {
        question: "What are the payment options available?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash for your convenience."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ravi Bhandarkar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We traveled to Trimbakeshwar in an Innova Crysta from Pune. The cab was clean, comfortable, and the driver was very cooperative.”',
    },
    {
        name: 'Ms. Manisha Apte',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided excellent service for our religious trip to Trimbakeshwar. Highly recommended for family travel.”',
    },
];






































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneToTrimbakeshwarSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Trimbakeshwar Innova Crysta Cab",
  "description": "Book chauffeur-driven Innova Crysta taxi for a comfortable Pune to Trimbakeshwar journey. Ideal for religious trips, family tours, and weekend getaways. AC cab, one-way or round trip booking available online.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Pilgrimage Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Trimbakeshwar"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-trimbakeshwar-innova-crysta-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Trimbakeshwar Innova Crysta Cab | Pilgrimage Taxi Booking</title>
  <meta
    name="description"
    content="Chauffeur-driven Innova Crysta cab from Pune to Trimbakeshwar for pilgrimage and family trips. AC comfort, one-way or round trip available. Easy online booking with Meghana Cabs."
  />
  <meta
    name="keywords"
    content="Pune to Trimbakeshwar Innova Crysta Cab Booking, One Way Innova Crysta Pune Trimbakeshwar, Round Trip Innova Crysta Pune Trimbakeshwar, AC Innova Crysta Taxi Pune Trimbakeshwar, Chauffeur Driven Innova Crysta Pune Trimbakeshwar, Private Innova Crysta Taxi Pune Trimbakeshwar, Online Booking Innova Crysta Pune Trimbakeshwar, Trimbakeshwar Pilgrimage Innova Crysta, Comfortable Innova Crysta Cab Pune Trimbakeshwar, Budget Innova Crysta Taxi Pune Trimbakeshwar, Religious Tour Innova Crysta Pune, Family Trip Innova Crysta Trimbakeshwar, Reliable Innova Crysta Taxi Trimbakeshwar, Long Distance Innova Crysta Taxi, Weekend Trip Innova Crysta Trimbakeshwar"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToTrimbakeshwarSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/6.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetotrimkedhwarcrystacab;